import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  loginSuccess: false,
  navigationPage: null,
  error: null,
  goToSocialRegistration: false,
}

const slice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    loginAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    loginSocialAction: (state, action) => {
      state.loading = action.payload
      state.error = null
    },
    loginSuccessAction:(state, action)=>{
      state.loading = true
      state.error = null
      state.loginSuccess = true
      state.navigationPage =  action.payload
    },
    goToSocialRegistrationAction:(state)=>{
      state.goToSocialRegistration = true
    },
    loginErrorAction: (state, action) => {
      state.loading = false
      state.loginSuccess = false
      state.error = action.payload
      state.navigationPage = null
    },
    loginResetState: () => initialState,
  },
});

export const {
  loginAction,
  loginSuccessAction,
  loginErrorAction,
  loginResetState,
  loginSocialAction,
  goToSocialRegistrationAction,
} = slice.actions

export default slice.reducer
